// 版本更新记录-系统类型
export enum APP_SYSTEM_TYPE_ENUM {
  ios = 'ios',
  android = 'android'
}

export const APP_SYSTEM_TYPE_LIST = [
  { value: APP_SYSTEM_TYPE_ENUM.ios, label: 'IOS' },
  { value: APP_SYSTEM_TYPE_ENUM.android, label: 'Android' },
];

// 版本更新记录-更新级别
export enum APP_UPDATE_LEVEL_ENUM {
  force = 'force',
  optional = 'optional'
}

export const APP_UPDATE_LEVEL_LIST = [
  { value: APP_UPDATE_LEVEL_ENUM.force, label: '强制更新' },
  { value: APP_UPDATE_LEVEL_ENUM.optional, label: '可选更新' },
];
// 是否启用
export enum APP_IS_ENABLED_ENUM {
  /* 启用 */
  ENABLED = 'YES',
  /* 停用 */
  DISABLED = 'NO',
}

export const APP_IS_ENABLED_LIST = [
  { value: APP_IS_ENABLED_ENUM.ENABLED, label: '启用' },
  { value: APP_IS_ENABLED_ENUM.DISABLED, label: '停用' },
];
// APP客户端
export enum APP_LIST_ENUM {
  // eslint-disable-next-line camelcase
  octopus_app = '八爪鱼APP',
  // eslint-disable-next-line camelcase
  zhicloth_app = '致衣APP',
  // eslint-disable-next-line camelcase
  tiangong_app = '天工APP',
}

// 用户来源
export enum APP_USER_SOURCE {
  /* 百布 */
  BAIBU = 'BAIBU_SOURCE',
  /* SSO */
  SSO = 'NANJING_SSO_SOURCE'
}

export const APP_USER_SOURCE_LIST = [
  { value: APP_USER_SOURCE.BAIBU, label: '百布' },
  { value: APP_USER_SOURCE.SSO, label: 'SSO' },
  { value: '', label: '全部' },
];

// 在职状态
export enum WORK_STATUS_ENUM {
  /* 在职 */
  IN_SERVICE = '1',
  /* 离职 */
  RESIGN = '0'
}

export const WORK_STATUS_LIST = [
  { value: WORK_STATUS_ENUM.IN_SERVICE, label: '在职' },
  { value: WORK_STATUS_ENUM.RESIGN, label: '离职' },
  { value: '', label: '全部' },
];

// 更新维度
export enum UPDATE_DIMENSION_ENUM {
  DEPARTMENT = '1',
  APPLICATION = '2'
}
export const UPDATE_DIMENSION_LIST = [
  { value: UPDATE_DIMENSION_ENUM.DEPARTMENT, label: '部门维度' },
  { value: UPDATE_DIMENSION_ENUM.APPLICATION, label: '应用维度' },
];

// 用户体系
export enum USER_SYSTEM_ENUM {
  BAIBU = '1',
  SSO = '2'
}
export const USER_SYSTEM_LIST = [
  { value: USER_SYSTEM_ENUM.BAIBU, label: '百布' },
  { value: USER_SYSTEM_ENUM.SSO, label: '创新SSO' },
];

// 适配系统
export enum ADAPTATION_SYSTEM_ENUM {
  ios = '1',
  android = '0'
}
export const ADAPTATION_SYSTEM_LIST = [
  { value: ADAPTATION_SYSTEM_ENUM.ios, label: 'IOS' },
  { value: ADAPTATION_SYSTEM_ENUM.android, label: 'Android' },
];

// 停用启用
export enum ENABLED_STATUS_ENUM {
  ENABLED = '1',
  DISABLED = '0',
}
export const ENABLED_STATUS_LIST = [
  { value: ENABLED_STATUS_ENUM.ENABLED, label: '启用' },
  { value: ENABLED_STATUS_ENUM.DISABLED, label: '停用' },
];

// 重新构建App
export const REBUILD_APP_ENUM = {
  YES: true,
  NO: false,
};
export const REBUILD_APP_LIST = [
  { value: REBUILD_APP_ENUM.YES, label: '是' },
  { value: REBUILD_APP_ENUM.NO, label: '否' },
];
